import { render, staticRenderFns } from "./couponGroupStatistics.vue?vue&type=template&id=443c8836&scoped=true"
import script from "./couponGroupStatistics.vue?vue&type=script&lang=js"
export * from "./couponGroupStatistics.vue?vue&type=script&lang=js"
import style0 from "./couponGroupStatistics.vue?vue&type=style&index=0&id=443c8836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443c8836",
  null
  
)

export default component.exports